import React from "react";
import {Box, ListItemText, MenuItem, Select, Typography} from "@mui/material";
import {a} from "./authStyles";

// iso: ISO 3166-1 code (also picks the flag), dial: international calling code (digits only)
export const COUNTRIES = [
  {iso: "MK", name: "North Macedonia", dial: "389"},
  {iso: "XK", name: "Kosovo", dial: "383"},
  {iso: "AL", name: "Albania", dial: "355"},
  {iso: "RS", name: "Serbia", dial: "381"},
  {iso: "ME", name: "Montenegro", dial: "382"},
  {iso: "BA", name: "Bosnia and Herzegovina", dial: "387"},
  {iso: "HR", name: "Croatia", dial: "385"},
  {iso: "SI", name: "Slovenia", dial: "386"},
  {iso: "BG", name: "Bulgaria", dial: "359"},
  {iso: "GR", name: "Greece", dial: "30"},
  {iso: "RO", name: "Romania", dial: "40"},
  {iso: "HU", name: "Hungary", dial: "36"},
  {iso: "TR", name: "Türkiye", dial: "90"},
  {iso: "DE", name: "Germany", dial: "49"},
  {iso: "AT", name: "Austria", dial: "43"},
  {iso: "CH", name: "Switzerland", dial: "41"},
  {iso: "IT", name: "Italy", dial: "39"},
  {iso: "FR", name: "France", dial: "33"},
  {iso: "ES", name: "Spain", dial: "34"},
  {iso: "PT", name: "Portugal", dial: "351"},
  {iso: "GB", name: "United Kingdom", dial: "44"},
  {iso: "IE", name: "Ireland", dial: "353"},
  {iso: "NL", name: "Netherlands", dial: "31"},
  {iso: "BE", name: "Belgium", dial: "32"},
  {iso: "LU", name: "Luxembourg", dial: "352"},
  {iso: "SE", name: "Sweden", dial: "46"},
  {iso: "NO", name: "Norway", dial: "47"},
  {iso: "DK", name: "Denmark", dial: "45"},
  {iso: "FI", name: "Finland", dial: "358"},
  {iso: "PL", name: "Poland", dial: "48"},
  {iso: "CZ", name: "Czechia", dial: "420"},
  {iso: "SK", name: "Slovakia", dial: "421"},
  {iso: "UA", name: "Ukraine", dial: "380"},
  {iso: "US", name: "United States", dial: "1"},
  {iso: "CA", name: "Canada", dial: "1"},
  {iso: "AU", name: "Australia", dial: "61"},
  {iso: "AE", name: "United Arab Emirates", dial: "971"},
  {iso: "SA", name: "Saudi Arabia", dial: "966"},
  {iso: "IL", name: "Israel", dial: "972"},
  {iso: "IN", name: "India", dial: "91"},
];

export const DEFAULT_COUNTRY = "MK";

export const dialCodeOf = (iso) => COUNTRIES.find(country => country.iso === iso)?.dial || "";

// Flag as an image: Windows has no emoji flags, so the letters of the country would show instead
const Flag = ({iso}) => (
  <Box
    component={"img"}
    src={`https://flagcdn.com/w40/${iso.toLowerCase()}.png`}
    srcSet={`https://flagcdn.com/w80/${iso.toLowerCase()}.png 2x`}
    alt={""}
    loading={"lazy"}
    sx={{width: 22, height: 16, objectFit: "cover", borderRadius: "3px", flexShrink: 0}}
  />
);

// Country prefix inside the phone field (use as its startAdornment): flag, +code and a small arrow, no fill of its
// own. The country name is in the list.
export const CountryCodeSelect = ({value, onChange}) => (
  <Select
    variant={"standard"}
    disableUnderline
    value={value}
    onChange={(e) => onChange(e.target.value)}
    inputProps={{"aria-label": "Country code"}}
    renderValue={(iso) => (
      <Box sx={{display: "flex", alignItems: "center", gap: 0.9}}>
        <Flag iso={iso}/>
        <span>+{dialCodeOf(iso)}</span>
      </Box>
    )}
    MenuProps={{PaperProps: {sx: {maxHeight: 320, borderRadius: "12px", mt: 0.5}}}}
    sx={{
      fontSize: 14.5, color: a.ink, mr: 0.5,
      "& .MuiSelect-select": {display: "flex", alignItems: "center", py: 0, pl: 0, pr: "20px !important", bgcolor: "transparent !important"},
      "& .MuiSelect-icon": {right: 0, color: a.muted},
    }}
  >
    {COUNTRIES.map(country => (
      <MenuItem key={country.iso} value={country.iso} sx={{gap: 1.25}}>
        <Flag iso={country.iso}/>
        <ListItemText primary={country.name} primaryTypographyProps={{fontSize: 14}}/>
        <Typography sx={{fontSize: 13, color: a.muted}}>+{country.dial}</Typography>
      </MenuItem>
    ))}
  </Select>
);
